<template>
  <div class="page-container">
    <h1 class="page-title">家长监护</h1>
    
    <div class="content-section">
      <h2 class="section-title">工作介绍：</h2>
      <p class="section-text">
        "未成年人家长监护干预" 是由中华人民共和国原文化部指导创建，旨在加强家长对未成年人参与网络表演的监护，引导未成年人健康、绿色参与网络表演，和谐家庭关系的社会性公益行动。
      </p>
      <p class="section-text">
        "家长监护机制" 是新疆音线信息科技有限公司平台在这一公益行动中，针对目前未成年人缺乏自控及自律能力，容易陷入沉迷；少数监护人缺少时间照顾孩子，不能及时监督孩子游戏时间的现状，而推出的一种可由家长实施监控，纠正部分未成年子女沉迷网络表演的保护机制。
      </p>
    </div>
    
    <div class="content-section">
      <h2 class="section-title">流程介绍：</h2>
      <p class="section-text">
        监护人可通过邮件、电话等方式了解"未成年人家长监护工程"详细情况，由掌中星未成年人监护组专门客服人员告知下载相关申请材料填写后，邮寄或传真到掌中星客服部未成年人监护组。
      </p>
      <p class="section-text">
        未成年人监护组根据收到材料核实结果并回访监护人：
      </p>
      <ol class="process-list">
        <li>判断各项资料、信息完备真实后，通知账号所属人15日内若有疑问可向官方提出申诉，否则该账号将被封禁；</li>
        <li>若收到现账号所属人申诉、客服将要求监护人提供更加详实的账号信息，以确定账号归属或者协助找回账号后后续处理。</li>
      </ol>
      <p class="section-text">
        当通期账号所属人未申诉或者账号归属已明确，客服将封禁该账号写直到成年，并通知监护人处理结果。
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ParentalControl'
}
</script>

<style scoped>
.page-container {
  padding: 20px;
  max-width: 1000px;
  margin: 0 auto;
  padding-bottom: 40px;
}

.page-title {
  font-size: 24px;
  font-weight: 500;
  margin-bottom: 30px;
  color: #333;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
}

.content-section {
  margin-bottom: 30px;
}

.section-title {
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 15px;
  color: #333;
}

.section-text {
  font-size: 14px;
  line-height: 1.8;
  color: #333;
  margin-bottom: 15px;
  text-align: justify;
}

.process-list {
  padding-left: 20px;
  margin-bottom: 15px;
}

.process-list li {
  font-size: 14px;
  line-height: 1.8;
  color: #333;
  margin-bottom: 10px;
  text-align: justify;
}
</style> 